module.exports = __webpack_public_path__ + "img/s11.662f688.png";